import { Component, inject } from '@angular/core';
import { HlmIconComponent } from '../../../ui/icon.component';
import { PenguinService } from '../../../shared/penguin/penguin.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'spike-footer',
  standalone: true,
  imports: [HlmIconComponent],
  // Pass-through host so the inner <footer sticky bottom-0> anchors to the
  // flex parent (cmt-root > div), not to the spike-footer host's tiny box.
  host: { class: 'contents' },
  template: `
    <footer class="sticky bottom-0 z-40 border-t border-border bg-card/85 backdrop-blur-sm">
      <div class="flex h-8 items-center justify-between px-8">
        <div class="flex items-center gap-3 text-sm text-muted-foreground">
          <span class="font-mono-feat uppercase tracking-[0.18em]">AMIE</span>
          <span class="h-3 w-px bg-border"></span>
          <span class="font-mono-feat">v{{ version }}</span>
        </div>
        <div class="flex items-center gap-2 text-sm text-muted-foreground">
          <span>Built with</span>
          <span
            class="text-destructive heart cursor-pointer select-none"
            (dblclick)="penguin.trigger()"
            title="🐧"
          >
            <hlm-icon name="lucideHeart" size="0.85rem" />
          </span>
          <span>by Software Development</span>
          <span class="ml-2 font-mono-feat text-muted-foreground/60">© {{ currentYear }}</span>
        </div>
      </div>
    </footer>
  `,
  styles: [`
    @keyframes pulse {
      0%, 100% { transform: scale(1); }
      30% { transform: scale(1.25); }
      50% { transform: scale(1); }
      70% { transform: scale(1.15); }
    }
    .heart { display: inline-flex; animation: pulse 1.4s ease-in-out infinite; }
  `],
})
export class SpikeFooterComponent {
  // EB-3796: build-time-baked version via `inject-version` (replaces
  // `VERSION_PLACEHOLDER` in environment.development.ts / environment.production.ts).
  // Local `nx serve` shows '0.0.0-local' from environment.ts.
  readonly version = environment.appVersion;
  readonly currentYear = new Date().getFullYear();
  readonly penguin = inject(PenguinService);
}
